const globalStyles = {
  fieldWidth : '70%'

}

export default globalStyles;